import { type BaseItemSchema, asPassage } from "@memorang/types";

import { splitLayoutItemTypes } from "./item-types";

type SplitLayoutMetadataItem = {
	metadata?: {
		uiRendering?: {
			splitLayout?: boolean;
		};
	};
};

export const hasMetadataSplitLayout = (
	item: SplitLayoutMetadataItem | null | undefined,
) => Boolean(item?.metadata?.uiRendering?.splitLayout);

export const isListeningScenario = (
	item: Pick<BaseItemSchema, "metadata" | "recordType"> | null | undefined,
) =>
	item?.metadata?.skill === "LISTENING" &&
	(item.recordType === "SCENARIO" || hasMetadataSplitLayout(item));

export const isStudySessionSplitLayout = (
	item:
		| Pick<BaseItemSchema, "metadata" | "recordType" | "stimulus">
		| null
		| undefined,
	isMobile: boolean,
): boolean => {
	const itemType = item?.metadata?.type;
	const passage = asPassage(item?.stimulus?.passage);
	return (
		Boolean(itemType != null && splitLayoutItemTypes.has(itemType)) ||
		Boolean(passage?.paragraphs?.length) ||
		Boolean(passage?.title?.length && !isMobile) ||
		Boolean(
			(item?.recordType === "SCENARIO" || hasMetadataSplitLayout(item)) &&
				!isMobile,
		)
	);
};
